module.exports = __webpack_public_path__ + "img/kirin_logo.e8c41674.png";